import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import { visuallyHidden } from "@mui/utils";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import Button from "react-bootstrap/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Pagination from "@mui/material/Pagination";
import { Link } from "react-router-dom";
import Radio from "@mui/material/Radio";
import Checkbox from "@mui/material/Checkbox";
import _ from "lodash";
import { List, ListItem } from "@mui/material";
import moment from "moment";
import FlagSharpIcon from "@mui/icons-material/FlagSharp";
import { S3_URL } from "../services/Constants";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import {
  LTALB,
  AOELALB,
  RLANLB,
  STANB,
  CTACB,
  SFTAFB,
  PFTAFB,
  RTARB,
  RERB,
} from "../util/component-codes";
import {
  auditLogFormatAction,
  transactionLogFormatAction,
} from "../util/common";
import Cookies from "js-cookie";

const IDSTable = (props) => {
  const {
    isErrorScreen,
    isUnknownFacilityErrorScreen,
    noButtons,
    isRulesLoincTable,
    isRulesSnomedTable,
    isDiscardQueueTable,
    isEicrDiscardQueueTable,
    setPageNoCallback,
    setRecordsPerPageCallback,
    isLoincTable,
    isSnomedTable,
    isSendingFacilityTable,
    isRulesTable,
    isUnknownFacilityTable,
    isTransactionErrorTable,
    isConditionTable,
    isReportsTable,
    isMasterQueue,
    isEicrMasterQueue,
    showDateRange,
    isAoeLoincTable,
    isReportingLoincTable,
    isRepLoincTable,
    isAllSelected,
    setIsAllSelected,
    isAllSelectedDisabled,
    hasDeleteRowOption,
    setSelectedRemoveRowCallback,
    isPerfFacilityTable,
    isUserRoleManagementScreen,
    isRoleAndPermissionsScreen,
    isLogsScreen,
    isDuplicateQueue,
    isEICRErrorMessageQueue,
    filter,
    pageNo,
  } = props;
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState(null);
  const [multipleSelected, setMultipleSelected] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(
    Cookies.get("itemsPerPage") ? Cookies.get("itemsPerPage") : 5
  );
  const [page, setPage] = useState(pageNo?(pageNo+1):1);

  const [user] = useContext(UserContext);

  useEffect(() => {
    if (page > props.pages) setPage(props.pages);
    // else
    //   setPage(1);
    if (page === 0) setPage(1);

    if (
      props.selectedRows !== undefined &&
      props.selectedRows !== null &&
      props.selectedRows.length > 0
    )
      handleInitialMultipleSelectClick(props.selectedRows);
  }, [props.pages]);

  useEffect(() => {
    setMultipleSelected([]);
  }, [props.dataCondition]);

  const handleItemsPerPage = (event) => {
    if (event.target.value === null) {
      setRowsPerPage(5);
    } else {
      setRowsPerPage(event.target.value);
      setRecordsPerPageCallback(event.target.value);
      Cookies.set("itemsPerPage", JSON.stringify(event.target.value), {
        expires: 7,
      });
      setPageNoCallback(0);
      setPage(1);
    }
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = props.rows;
      setMultipleSelected(newSelected);
      props.setSelectedRowCallback(newSelected);
      return;
    }
    setMultipleSelected([]);
    props.setSelectedRowCallback([]);
  };
  const handleChangePage = (event, value) => {
    setPage(value);
    setPageNoCallback(value - 1);
  };

  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  const getComparator = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  };

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#EFEFEF",
      fontWeight: "bold",
      fontSize: 16,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 16,
    },
  }));

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClick = (event, row) => {
    setSelected(row);
    props.setSelectedRowCallback(row);
  };

  const handleMultipleSelectedAction = (
    multipleSelectedRows,
    row,
    selectedIndex
  ) => {
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(multipleSelectedRows, row);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(multipleSelectedRows.slice(1));
    } else if (selectedIndex === multipleSelectedRows.length - 1) {
      newSelected = newSelected.concat(multipleSelectedRows.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        multipleSelectedRows.slice(0, selectedIndex),
        multipleSelectedRows.slice(selectedIndex + 1)
      );
    }
    return newSelected;
  };

  const handleMultipleSelectClick = (event, row) => {
    let multipleSelectedRows = props.selectedRows;
    let selectedIndex = [];
    let newSelected = [];

    if (isRulesLoincTable) {
      selectedIndex = multipleSelected.findIndex(
        (item) => item.loincId === row.loincId
      );
      newSelected = handleMultipleSelectedAction(
        multipleSelected,
        row,
        selectedIndex
      );
    } else if (isRulesSnomedTable) {
      selectedIndex = multipleSelected.findIndex(
        (item) => item.snomedId === row.snomedId
      );
      newSelected = handleMultipleSelectedAction(
        multipleSelected,
        row,
        selectedIndex
      );
    } else if (
      isTransactionErrorTable ||
      isUnknownFacilityTable ||
      isDuplicateQueue ||
      isEICRErrorMessageQueue
    ) {
      selectedIndex = multipleSelectedRows.findIndex(
        (item) => item.transactionId === row.transactionId
      );
      newSelected = handleMultipleSelectedAction(
        multipleSelectedRows,
        row,
        selectedIndex
      );
    }
    (isTransactionErrorTable ||
      isUnknownFacilityTable ||
      isDuplicateQueue ||
      isEICRErrorMessageQueue) &&
      setIsAllSelected(false);
    setMultipleSelected(newSelected);
    props.setSelectedRowCallback(newSelected);
  };

  const handleInitialMultipleSelectClick = (selectedRows) => {
    setMultipleSelected(selectedRows);
    props.setSelectedRowCallback(selectedRows);
  };

  const hasAccessToAddButton = () => {
    if (
      componentIsVisible(LTALB, user) &&
      props.addButtonName === "Add New LOINC"
    ) {
      return true;
    } else if (
      componentIsVisible(AOELALB, user) &&
      props.addButtonName === "Add New AOE LOINC"
    ) {
      return true;
    } else if (
      componentIsVisible(RLANLB, user) &&
      props.addButtonName === "Add new Reporting LOINC"
    ) {
      return true;
    } else if (
      componentIsVisible(STANB, user) &&
      props.addButtonName === "Add New SNOMED"
    ) {
      return true;
    } else if (
      componentIsVisible(CTACB, user) &&
      props.addButtonName === "Add New Condition"
    ) {
      return true;
    } else if (
      componentIsVisible(SFTAFB, user) &&
      props.addButtonName === "Add New Sending Facility"
    ) {
      return true;
    } else if (
      componentIsVisible(PFTAFB, user) &&
      props.addButtonName === "Add New Performing Facility"
    ) {
      return true;
    } else if (
      componentIsVisible(RTARB, user) &&
      props.addButtonName === "Add New Rule"
    ) {
      return true;
    } else if (
      componentIsVisible(RERB, user) &&
      props.addButtonName === "Export to Excel"
    ) {
      return true;
    }
    return false;
  };

  const EnhancedTableToolbar = (props) => {
    return (
      <div className="tableToolbar flexCenter">
        {props.buttonsLayout && props.buttonsLayout()}
        <div className="flexCenter">
          {!isUnknownFacilityErrorScreen &&
            !noButtons &&
            !isErrorScreen &&
            !isLogsScreen &&
            !isUserRoleManagementScreen &&
            !isRoleAndPermissionsScreen &&
            !isReportingLoincTable && (
              <Button
                className={
                  filter
                    ? Object.keys(filter).length === 0
                      ? "tableFilterByBtn flexCenter generalFont"
                      : "addNewBtn flexCenter generalFont"
                    : "tableFilterByBtn flexCenter generalFont"
                }
                onClick={props.handleShowFilter}
                disabled={isReportsTable && selected === null}
              >
                <img
                  src={
                    isReportsTable
                      ? `${validateAndSanitizeUrl(S3_URL)}arrow-down-blue.png`
                      : `${validateAndSanitizeUrl(S3_URL)}filter-icon.png`
                  }
                  alt=""
                  style={{ marginRight: "10px" }}
                ></img>
                {isReportsTable ? showDateRange : "Filter by"}
              </Button>
            )}
          {!isRulesLoincTable &&
            !isRulesSnomedTable &&
            !isMasterQueue &&
            !isEicrMasterQueue &&
            !noButtons &&
            !isRoleAndPermissionsScreen &&
            !isUserRoleManagementScreen &&
            !isDiscardQueueTable &&
            !isEicrDiscardQueueTable &&
            hasAccessToAddButton() && (
              <Button
                className="addNewBtn flexCenter generalFont"
                onClick={props.addButtonAction}
                disabled={isReportsTable && selected === null}
              >
                <img
                  src={
                    isReportsTable
                      ? `${validateAndSanitizeUrl(S3_URL)}export-icon.png`
                      : `${validateAndSanitizeUrl(S3_URL)}plus-icon.png`
                  }
                  alt=""
                  style={{ marginRight: "10px" }}
                ></img>
                {props.addButtonName}
              </Button>
            )}
        </div>
      </div>
    );
  };

  const EnhancedTableHead = (props) => {
    const {
      order,
      orderBy,
      onRequestSort,
      headCells,
      numSelected,
      onSelectAllClick,
      rowCount,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {(isTransactionErrorTable ||
            isUnknownFacilityTable ||
            isDuplicateQueue ||
            isEICRErrorMessageQueue) && (
            <StyledTableCell>
              <Checkbox
                color="primary"
                disabled={isAllSelectedDisabled}
                indeterminate={numSelected > 0 && !isAllSelected}
                checked={numSelected > 0 && !isAllSelected}
                onChange={onSelectAllClick}
                inputProps={{
                  "aria-label": "select all desserts",
                }}
              />
            </StyledTableCell>
          )}
          {!isErrorScreen &&
            !isLogsScreen &&
            !isMasterQueue &&
            !isEicrMasterQueue &&
            !isUnknownFacilityErrorScreen &&
            !noButtons &&
            !isRoleAndPermissionsScreen &&
            !isReportingLoincTable &&
            !isTransactionErrorTable && <StyledTableCell></StyledTableCell> &&
            !isUnknownFacilityTable && <StyledTableCell></StyledTableCell> &&
            !isEICRErrorMessageQueue && <StyledTableCell></StyledTableCell> &&
            !isDuplicateQueue && <StyledTableCell></StyledTableCell>}
          {headCells.map((headCell) => (
            <StyledTableCell
              key={headCell.id}
              align="left"
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </StyledTableCell>
          ))}
          {hasDeleteRowOption && <StyledTableCell></StyledTableCell>}
        </TableRow>
      </TableHead>
    );
  };

  const isSelected = (row) => {
    let id = "";
    if (isLoincTable) {
      id = "loincId";
    } else if (isSnomedTable) {
      id = "snomedId";
    } else if (isSendingFacilityTable) {
      id = "sendingFacilityId";
    } else if (isPerfFacilityTable) {
      id = "performingFacilityId";
    } else if (
      isUnknownFacilityTable ||
      isDiscardQueueTable ||
      isEicrDiscardQueueTable ||
      isTransactionErrorTable ||
      isDuplicateQueue ||
      isEICRErrorMessageQueue
    ) {
      id = "transactionId";
    } else if (isRulesTable) {
      id = "ruleId";
    } else if (isConditionTable) {
      id = "conditionId";
    } else if (isReportsTable) {
      id = "reportId";
    } else if (isAoeLoincTable) {
      id = "aoeLoincId";
    } else if (isRepLoincTable || isReportingLoincTable) {
      id = "reportingLoincId";
    } else if (isUserRoleManagementScreen) {
      id = "userId";
    } else if (isRoleAndPermissionsScreen) {
      id = "roleId";
    }
    return id !== "" ? _.isEqual(selected?.[id], row?.[id]) : false;
  };

  const isMultipleSelected = (row) => {
    if (isRulesLoincTable) {
      let value = multipleSelected.filter(
        (item) => item.loincId === row.loincId
      );
      return _.isEqual(value[0]?.loincId, row.loincId);
    } else if (isRulesSnomedTable) {
      let value = multipleSelected.filter(
        (item) => item.snomedId === row.snomedId
      );
      return _.isEqual(value[0]?.snomedId, row.snomedId);
    } else if (isTransactionErrorTable) {
      let value = multipleSelected.filter(
        (item) => item.transactionId === row.transactionId
      );
      return (
        _.isEqual(value[0]?.transactionId, row.transactionId) || isAllSelected
      );
    } else if (isEICRErrorMessageQueue) {
      let value = multipleSelected.filter(
        (item) => item.transactionId === row.transactionId
      );
      return (
        _.isEqual(value[0]?.transactionId, row.transactionId) || isAllSelected
      );
    } else if (isUnknownFacilityTable || isDuplicateQueue) {
      let value = multipleSelected.filter(
        (item) => item.transactionId === row.transactionId
      );
      return (
        _.isEqual(value[0]?.transactionId, row.transactionId) || isAllSelected
      );
    }
  };

  const renderData = (row, key) => {
    switch (key) {
      case "transactionId":
        if (isLogsScreen) {
          return row[key] != null && row[key] !== "" ? row[key] : "-";
        } else {
          return (
            <Link
              className="linkStyle"
              to={"/error"}
              state={{
                transactionId: row.transactionId,
                isMasterQueue: isMasterQueue,
                isDuplicateQueue: isDuplicateQueue,
                isUnknownFacilityTable: isUnknownFacilityTable,
                isTransactionErrorTable: isTransactionErrorTable,
                isDiscardQueueTable: isDiscardQueueTable,
                isEicrMasterQueue: isEicrMasterQueue,
                isEicrDiscardQueueTable: isEicrDiscardQueueTable,
                isEICRErrorMessageQueue: isEICRErrorMessageQueue,
                filter: filter,
                pageNo: pageNo,
              }}
            >
              {row[key]}
            </Link>
          );
        }
      case "roleName":
        return (
          <Link
            className="linkStyle"
            to={"/permissions"}
            state={{
              row: row,
            }}
          >
            {row[key]}
          </Link>
        );
      case "messageId":
        return (
          <Link className="linkStyle" to={"/unknownFacility"}>
            {row[key]}
          </Link>
        );
      case "isActive":
        return (
          <div
            style={{ maxWidth: "150px" }}
            className={`${row[key] ? "activeColStyle" : "inactiveColStyle"}`}
            to={"/error"}
          >
            {row[key] ? "Active" : "Inactive"}
          </div>
        );
      case "qnInterpretation":
        return (
          <div className={`${row[key] == "Yes" && "boldBlueText"}`}>
            {row[key]}
          </div>
        );
      case "sendingFacilityNames":
        return (
          <List>
            {row[key].map((item, i) => (
              <ListItem className="noPaddL" key={i}>
                {item}
              </ListItem>
            ))}
          </List>
        );
      case "transactionError":
        return (
          <List>
            {row[key].slice(0, 3).map((item, i) => (
              <ListItem className="noPaddL" key={i}>
                {item?.errorRef?.errorDisplayName} ({item?.errorRef?.errorCode})
              </ListItem>
            ))}
          </List>
        );
      case "user":
        return row?.firstName && row?.lastName
          ? `${row.firstName} ${row.lastName}`
          : "-";
      case "roles":
        return (
          <List>
            {row[key].map((item, i) => (
              <ListItem className="noPaddL" key={i}>
                {item?.roleName}
              </ListItem>
            ))}
          </List>
        );
      case "patient":
        return row[key]?.fname && row[key]?.lname
          ? `${row[key]?.fname} ${row[key]?.lname}`
          : "-";
      case "sendingFacility":
        return row[key]?.clia ? row[key]?.clia : "-";
      case "transactionReceivedDate":
        return row[key] ? moment(row[key]).format("MM/DD/YYYY HH:mm") : "-";
      case "updatedDate":
        return row[key] && row.status === "PROCESSED"
          ? moment(row[key]).format("MM/DD/YYYY HH:mm")
          : "-";
      case "dateActivated":
        return row[key] ? moment(row[key]).format("MM/DD/YYYY") : "-";
      case "dateDeActivated":
        return row[key] ? moment(row[key]).format("MM/DD/YYYY") : "-";
      case "qaFlag":
        return row[key] && <FlagSharpIcon color="error" />;
      case "status":
        let color = "";
        if (row[key] === "PROCESSED") {
          color = "#00a91c";
        } else if (row[key] === "ERROR") {
          color = "#d54309";
        } else {
          color = "#0040AD";
        }
        return <div style={{ color: `${color}` }}>{row[key]}</div>;
      case "reportingLoincCode":
        if (isReportingLoincTable) {
          return row[key] != null && row[key] !== "" ? row[key] : "-";
        } else {
          return (
            <button
              type="button"
              className="linkStyle btn btn-link"
              onClick={() =>
                props.showReportingLoincDetails(row.reportingLoincId)
              }
            >
              {row[key]}
            </button>
          );
        }
      case "loincCode":
        if (isRulesLoincTable || noButtons || isRepLoincTable) {
          return row[key] != null && row[key] !== "" ? row[key] : "-";
        } else {
          return (
            <button
              type="button"
              className="linkStyle btn btn-link"
              onClick={() => props.getLoincDetails(row.loincId)}
            >
              {row[key]}
            </button>
          );
        }
      case "sendingFacilityName":
        if (isSendingFacilityTable) {
          return (
            <button
              type="button"
              className="linkStyle btn btn-link"
              onClick={() => props.getFacilityDetails(row.sendingFacilityId)}
            >
              {row[key]}
            </button>
          );
        } else {
          return row[key] != null && row[key] !== "" ? row[key] : "-";
        }
      case "performingFacilityName":
        if (isPerfFacilityTable) {
          return (
            <button
              type="button"
              className="linkStyle btn btn-link"
              onClick={() => props.getFacilityDetails(row.performingFacilityId)}
            >
              {row[key]}
            </button>
          );
        } else {
          return row[key] != null && row[key] !== "" ? row[key] : "-";
        }
      case "action":
        return (
          <div style={{ overflowWrap: "anywhere", maxWidth: "250px" }}>
            {auditLogFormatAction(row)}
          </div>
        );
      case "source":
        if (row?.source !== "Exception") {
          return (
            <div style={{ overflowWrap: "anywhere", maxWidth: "250px" }}>
              {transactionLogFormatAction(row)}
            </div>
          );
        }
      case "created":
        return "Rules Engine";
      case "createdDate":
        return row[key] ? moment(row[key]).format("MM/DD/YYYY HH:mm") : "-";
      default:
        return (
          <div style={{ overflowWrap: "anywhere", maxWidth: "250px" }}>
            {row[key] != null && row[key] !== "" ? row[key] : "-"}
          </div>
        );
    }
  };

  return (
    <>
      <Box
        sx={{
          width:
            isErrorScreen ||
            isUnknownFacilityErrorScreen ||
            isRulesLoincTable ||
            isRulesSnomedTable ||
            isReportingLoincTable ||
            noButtons
              ? "100%"
              : "95%",
        }}
      >
        <Paper>
          {props.buttonsLayout && (
            <EnhancedTableToolbar
              buttonsLayout={props.buttonsLayout}
              addButtonName={props.addButtonName}
              addButtonAction={props.addButtonAction}
              closeButtonAction={props.closeButtonAction}
              handleShowFilter={props.handleShowFilter}
            />
          )}

          <TableContainer>
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={"medium"}
            >
              <EnhancedTableHead
                numSelected={multipleSelected && multipleSelected.length}
                onSelectAllClick={handleSelectAllClick}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                headCells={props.headCells}
                rowCount={props.rows && props.rows.length}
                hasDeleteRowOption={hasDeleteRowOption}
              />
              <TableBody>
                {props.rows == null && !props.isFetchError && (
                  <TableRow>
                    <StyledTableCell colSpan={12} className="tableNoContent">
                      <div className="spinner">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                      </div>
                    </StyledTableCell>
                  </TableRow>
                )}
                {props.isFetchError && (
                  <TableRow>
                    <StyledTableCell colSpan={12} className="tableNoContent">
                      Something went wrong, please try again later!
                    </StyledTableCell>
                  </TableRow>
                )}
                {props?.rows?.length === 0 && (
                  <TableRow>
                    <StyledTableCell colSpan={12} className="tableNoContent">
                      No records found!
                    </StyledTableCell>
                  </TableRow>
                )}
                {props?.rows?.length > 0 &&
                  !props.isFetchError &&
                  stableSort(props.rows, getComparator(order, orderBy)).map(
                    (row, index) => {
                      const labelId = `enhanced-table-radio-${index}`;
                      let isItemSelected =
                        isRulesLoincTable ||
                        isRulesSnomedTable ||
                        isTransactionErrorTable ||
                        isUnknownFacilityTable ||
                        isDuplicateQueue ||
                        isEICRErrorMessageQueue
                          ? // ||
                            // isReportingLoincTable
                            isMultipleSelected(row)
                          : isSelected(row);
                      const headerValues = props.headCells.map(
                        (item) => item.id
                      );
                      return (
                        <TableRow
                          hover
                          onClick={(event) =>
                            isRulesLoincTable ||
                            isRulesSnomedTable ||
                            isTransactionErrorTable ||
                            isUnknownFacilityTable ||
                            isDuplicateQueue ||
                            isEICRErrorMessageQueue
                              ? // ||
                                // isReportingLoincTable
                                handleMultipleSelectClick(event, row)
                              : handleClick(event, row)
                          }
                          role="radio"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={index}
                          selected={isItemSelected}
                        >
                          {!isErrorScreen &&
                            !isLogsScreen &&
                            !isMasterQueue &&
                            !isEicrMasterQueue &&
                            !isUnknownFacilityErrorScreen &&
                            !isReportingLoincTable &&
                            !isRoleAndPermissionsScreen &&
                            !noButtons && (
                              <StyledTableCell>
                                {isRulesLoincTable ||
                                isRulesSnomedTable ||
                                isTransactionErrorTable ||
                                isUnknownFacilityTable ||
                                isDuplicateQueue ||
                                isEICRErrorMessageQueue ? (
                                  // ||
                                  // isReportingLoincTable
                                  <Checkbox
                                    color="primary"
                                    checked={isItemSelected}
                                    inputProps={{
                                      "aria-labelledby": labelId,
                                    }}
                                  />
                                ) : (
                                  <Radio
                                    color="primary"
                                    checked={isItemSelected}
                                    inputProps={{
                                      "aria-labelledby": labelId,
                                    }}
                                  />
                                )}
                              </StyledTableCell>
                            )}
                          {headerValues.map((key) => {
                            return (
                              <StyledTableCell key={key}>
                                {renderData(row, key)}
                              </StyledTableCell>
                            );
                          })}
                          {hasDeleteRowOption && (
                            <StyledTableCell colSpan={12}>
                              {" "}
                              <Button
                                onClick={(event) =>
                                  setSelectedRemoveRowCallback(row)
                                }
                                className="removeButtonStyle generalFont flexCenter "
                              >
                                {" "}
                                <img
                                  src={`${validateAndSanitizeUrl(
                                    S3_URL
                                  )}delete-icon.png`}
                                  className="buttonIcon"
                                  alt=""
                                ></img>
                              </Button>
                            </StyledTableCell>
                          )}
                        </TableRow>
                      );
                    }
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        {!isUnknownFacilityErrorScreen &&
          !isErrorScreen &&
          !noButtons &&
          !isReportsTable && (
            <>
              <br />
              <div className="pagContainer flexCenter">
                <div className="flexCenter">
                  <label style={{ marginRight: "8px" }}>Show</label>

                  <Select
                    sx={{ minWidth: 80, maxHeight: 40, background: "white" }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={rowsPerPage}
                    autoWidth
                    onChange={handleItemsPerPage}
                  >
                    <MenuItem value={5}>5 </MenuItem>
                    <MenuItem value={15}>15 </MenuItem>
                    <MenuItem value={25}>25 </MenuItem>
                    <MenuItem value={50}>50 </MenuItem>
                    <MenuItem value={100}>100 </MenuItem>
                  </Select>
                  <label style={{ marginLeft: "8px" }}>results per page</label>
                </div>
                <div className="flexCenter">
                  <Pagination
                    variant="outlined"
                    shape="rounded"
                    count={props.pages}
                    page={page}
                    onChange={handleChangePage}
                    defaultPage={1}
                    color="primary"
                    size="medium"
                  ></Pagination>
                </div>
              </div>
            </>
          )}
      </Box>
    </>
  );
};

export default IDSTable;
